// api.js
import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API_URL;

export const updateTourStatus = async () => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) return Promise.reject("Unauthorized");

  try {
    const response = await axios.post(
      `${BASE_URL}authentication/update-tour-status`,
      {},
      {
        headers: {
          'accept': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error:', error.response ? error.response.data : error.message);
    throw error;
  }
};
